// extracted by mini-css-extract-plugin
export default {"hist":"NotePreview_hist__1haks"};